import { useJsApiLoader } from "@react-google-maps/api"
import { getLocalization, SecureKey } from "../constants"
import { LocationContext } from "./LocationContext"
const libraries = ['places', 'geocoding', 'maps']
const LocationProvider = ({ children }) => {
    const { isLoaded } = useJsApiLoader({
        'id': 'google-map-script',
        googleMapsApiKey: SecureKey.googleMapKey,
        libraries: libraries,
        language: getLocalization() || 'fr'
    })
    return (
        <LocationContext.Provider
            value={{
                isLoaded: isLoaded
            }}
        >
            {children}
        </LocationContext.Provider>
    )
}

export default LocationProvider